import {
  Button,
  createStyles,
  makeStyles,
  Theme,
  Tooltip,
  Typography,
} from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { FC } from "react";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  setCarAddFormEnabled(): void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonText: {
      textTransform: "capitalize",
      color: "white",
    },
  }),
);

export const AddCarButton: FC<Props> = ({ setCarAddFormEnabled }) => {
  const { t } = useTranslation("audits");
  const classes = useStyles();

  const handleAddCarClick = () => {
    setCarAddFormEnabled();
  };

  return (
    <>
      <Tooltip title={t<string>("audits:addCarTooltip")} arrow={true}>
        <Button
          onClick={() => handleAddCarClick()}
          className={classes.buttonText}
        >
          <AddCircleOutlineIcon style={{ fill: "white", fontSize: 28 }} />
          <Typography variant="body1">{t("audits:addCar")}</Typography>
        </Button>
      </Tooltip>
    </>
  );
};
